import React from "react";
import Meta from "./../components/Meta";
import VideoGeneratorSection from "./../components/VideoGeneratorSection";

function CreateVideoPage() {
  document.title = "NSFW AI Video Generator";

  return (
    <>
      <Meta
        title="NSFW AI Video Generator"
        description="Turn your prompts or AI-generated images into NSFW videos. Powered by our new video animation model."
      />
      <VideoGeneratorSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Animate Your Fantasy"
        subtitle="Type a prompt or pick one of your AI-generated images and turn it into a short NSFW video — no upload required."
        buttonAction="Generate video"
      />
    </>
  );
}

export default CreateVideoPage;
